<template>
    <div>
        <b-modal 
            size="lg"
            v-model="exIdentity.show"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer  
            @hidden="$emit('close')"     
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center px-4">
                        <div class="col-12">
                            <h3 class="mb-0"> การถ่ายรูปคู่กับบัตรประชาชน </h3>
                            <small class="text-muted">*ข้อมูลของคุณจะถูกเก็บเอย่างปลอดภัยในระบบของเราและเป็นความลับ</small>
                        </div>
                    </div>
                </div>
            </template>
            <div class="container-fluid pb-3">
                <div class="row pb-4 text-center">
                    <div class="col-6">
                        <div class="text-center pt-2">
                            <img :src="require('../../../assets/images/correct.png')" alt="Image" width="200" height="280">
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="text-center pt-2">
                            <img :src="require('../../../assets/images/notcorrect.png')" alt="Image" width="200" height="280">
                        </div>
                    </div>
                </div>
                <div class="row px-4">
                    <div class="col-12">
                        <h4>ข้อควรระวัง</h4>
                        <h4>1.ภาพถ่ายจะต้องสามารถมองเห็นใบหน้าและบัตรประชาชนได้อย่างชัดเจน</h4>
                        <h4>2.ควรถ่ายรูปในท่าใบหน้าตรง ไม่ใส่แว่นตาสีดำและหมวก</h4>
                        <h4>3.โปรดถ่ายรูปบัตรประชาชนตัวจริงจากกล้องมือถือจริง ไม่สามารถใช้สำเนาหรือภาพถ่ายได้</h4>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalExampleIdentity" ,
    props: {
        exIdentity: Object,
    },
}
</script>
<style scoped>

</style>